import { useState } from "react";
import { Button, Form, Modal, message } from "antd";

import Heading from "components/Heading/Heading";
import DataTable from "components/Tables/DataTable";
import {
  useAddUnitMutation,
  useDeleteUnitMutation,
  useEditUnitMutation,
  useGetUnitsQuery,
} from "../../../redux/Service/units";
import FormModal from "./FormModal";

function Units() {
  const [form] = Form.useForm();
  const [isModalOpen, setIsModalOpen] = useState<boolean>(false);
  const [isEditing, setIsEditing] = useState<boolean>(false);

  const { data: unitsData, isLoading, isError } = useGetUnitsQuery(undefined);

  const units = unitsData?.ResponseObject ?? [];

  const [addUnit, { isLoading: isAdding }] = useAddUnitMutation();
  const [updateUnit, { isLoading: isUpdating }] = useEditUnitMutation();
  const [deleteUnit, { isLoading: isDeleting }] = useDeleteUnitMutation();

  const columns: any = [
    {
      title: "كود الوحدة",
      dataIndex: "UnitID",
      key: "UnitID",
    },
    {
      title: "اسم الوحدة",
      dataIndex: "UnitName",
      key: "UnitName",
      width: 120,
    },
  ];

  const handleOk = async (values) => {
    try {
      let response;

      if (isEditing) {
        response = await updateUnit(values).unwrap(); // update request
      } else {
        response = await addUnit(values).unwrap(); // add request
      }

      if (response?.ResponseObject === true) {
        message.success(
          isEditing ? "تم تعديل الوحدة بنجاح" : "تمت إضافة الوحدة بنجاح"
        );
        setIsModalOpen(false);
        resetModal();
      } else {
        message.error("حدث خطأ أثناء العملية");
      }
    } catch (error) {
      message.error("فشل الاتصال بالخادم");
    }
  };

  function resetModal() {
    form.resetFields();
    setIsEditing(false);
  }

  const handleCancel = () => {
    setIsModalOpen(false);
    resetModal();
  };

  const handleDeleteClick = (record: any) => {
    Modal.confirm({
      title: "تأكيد الحذف",
      content: `هل أنت متأكد أنك تريد حذف الوحدة "${record.UnitName}"؟`,
      okText: "حذف",
      okType: "danger",
      cancelText: "إلغاء",
      onOk: async () => {
        try {
          const response = await deleteUnit(record.UnitID).unwrap();

          if (response?.ResponseObject === true) {
            message.success("تم حذف الوحدة بنجاح");
          } else {
            message.error("حدث خطأ أثناء الحذف");
          }
        } catch (error) {
          message.error("فشل الاتصال بالخادم");
        }
      },
    });
  };

  const handleEditClick = (record: any) => {
    setIsEditing(true);
    setIsModalOpen(true);

    setTimeout(() => {
      form.setFieldsValue(record);
    }, 0);
  };

  return (
    <>
      <div className="flex flex-wrap gap-4 relative">
        <div className="grid justify-start my-2">
          <Button
            type="primary"
            style={{ width: "10rem" }}
            onClick={() => setIsModalOpen(true)}
          >
            إضافه
          </Button>
        </div>

        <FormModal
          form={form}
          units={units}
          isEditing={isEditing}
          isModalOpen={isModalOpen}
          handleOk={handleOk}
          handleCancel={handleCancel}
          loading={isUpdating || isAdding}
        />

        <DataTable
          columns={columns}
          data={units}
          handleEditClick={handleEditClick}
          handleDeletClick={handleDeleteClick}
          isLoading={isLoading || isDeleting}
        />
      </div>
    </>
  );
}

export default Units;
